import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2ae4c90"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indicators-statistic-table" }
const _hoisted_2 = { class: "indicators-statistic-table__content" }

import { ref } from 'vue'
import ru from 'element-plus/es/locale/lang/ru'
import { StatisticDoctorType } from '@/shared/types'

interface Props {
  tablePropsData: Array<StatisticDoctorType>
  summary: StatisticDoctorType
}


export default /*#__PURE__*/_defineComponent({
  props: {
    tablePropsData: null,
    summary: null
  },
  setup(__props: any) {

const props = __props as {
  tablePropsData: Array<StatisticDoctorType>
  summary: StatisticDoctorType
}

const loading = ref(false)



const getRowClassName = (row: any) => {
  if (row.rowIndex === 0) {
    return 'white-row-bold'
  }

  return 'white-row'
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_config_provider, { locale: _unref(ru) }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            class: "table",
            "row-class-name": getRowClassName,
            "cell-class-name": "white-cell",
            "max-height": "490",
            data: __props.tablePropsData,
            "default-sort": { prop: 'reports_count', order: 'descending' }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "Имя",
                width: "300"
              }),
              _createVNode(_component_el_table_column, {
                prop: "reports_count",
                label: "Индекс Налёта",
                width: "155",
                sortable: ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "brush_maps_count",
                label: "Карта ёршиков",
                width: "155",
                sortable: ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "screenings_count",
                label: "Скрининг",
                width: "120",
                sortable: ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "periodontologies_count",
                label: "Пародонтальная карта",
                width: "210",
                sortable: ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "total_report_count",
                label: "Всего отчётов",
                width: "150",
                sortable: ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "distinct_patients_count",
                label: "Уникальные пациенты",
                width: "220",
                sortable: ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "first_time_patient_average_index",
                label: "СИГ перв. пациентов",
                width: "200",
                formatter: 
              (row, column, cellValue) =>
                cellValue !== null ? Math.round(cellValue) : ''
            ,
                sortable: ""
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                prop: "repeated_patient_average_index",
                label: "СИГ повт. пациентов",
                formatter: 
              (row, column, cellValue) =>
                cellValue !== null ? Math.round(cellValue) : ''
            ,
                sortable: ""
              }, null, 8, ["formatter"])
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, loading.value]
          ]),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            class: "table",
            "row-class-name": "white-row-bold",
            "cell-class-name": "white-cell",
            "max-height": "100",
            "show-header": false,
            data: [__props.summary]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "name",
                width: "300"
              }),
              _createVNode(_component_el_table_column, {
                prop: "reports_count",
                width: "155"
              }),
              _createVNode(_component_el_table_column, {
                prop: "brush_maps_count",
                width: "155"
              }),
              _createVNode(_component_el_table_column, {
                prop: "screenings_count",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "periodontologies_count",
                width: "210"
              }),
              _createVNode(_component_el_table_column, {
                prop: "total_report_count",
                width: "150"
              }),
              _createVNode(_component_el_table_column, {
                prop: "distinct_patients_count",
                width: "220"
              }),
              _createVNode(_component_el_table_column, {
                prop: "first_time_patient_average_index",
                width: "200",
                formatter: 
              (row, column, cellValue) =>
                cellValue !== null ? Math.round(cellValue) : ''
            
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                prop: "repeated_patient_average_index",
                formatter: 
              (row, column, cellValue) =>
                cellValue !== null ? Math.round(cellValue) : ''
            
              }, null, 8, ["formatter"])
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, loading.value]
          ])
        ]),
        _: 1
      }, 8, ["locale"])
    ])
  ]))
}
}

})